import { Component, OnInit } from '@angular/core';
import {
  EditQualifiedPersonInviteCommand,
  EmailInviteStatus,
  IQualifiedPersonInviteSearchViewModel
} from '@services/cleanfill-api/cleanfill-api.generated';
import { StoreQpInvitationService } from '@services/cleanfill-core/store-qp-invitation/store-qp-invitation.service';
import { SearchQuery } from '@view-models/search-query/search-query';
import { ConfirmDialogResult, ConfirmDialogType } from '@widgets/site-common/confirm-dialog/confirm-dialog.model';
import { ConfirmDialogService } from '@widgets/site-common/confirm-dialog/confirm-dialog.service';
import { Observable } from 'rxjs/internal/Observable';
enum InviteType {
  Invite = 'Invite',
  Admin_Invite = 'Admin_Invite'
}
@Component({
  selector: 'app-qp-invitations',
  templateUrl: './qp-invitations.component.html',
  styleUrls: ['./qp-invitations.component.scss']
})
export class QpInvitationsComponent implements OnInit {
  qpInvitations$: Observable<IQualifiedPersonInviteSearchViewModel[]>;
  totalQPInvitations$: Observable<number>;
  InviteType = InviteType;
  EmailInviteStatus = EmailInviteStatus;
  constructor(public qpInvitationService: StoreQpInvitationService, private dialogConfirmation: ConfirmDialogService) {}

  ngOnInit() {
    this.qpInvitations$ = this.qpInvitationService.qpInvitations$;
    this.totalQPInvitations$ = this.qpInvitationService.totalQPInvitations$;
  }

  async respondToInvite(invitation: IQualifiedPersonInviteSearchViewModel, status: EmailInviteStatus, type: InviteType) {
    let message;
    if (status === EmailInviteStatus.Accepted) {
      message =
        type === InviteType.Admin_Invite
          ? `Are you sure you would like to accept ${invitation?.companyName} Admin Access?`
          : `Are you sure you would like to accept ${invitation?.companyName} invitation?`;
    }
    if (status === EmailInviteStatus.Rejected) {
      message =
        type === InviteType.Admin_Invite
          ? `Are you sure you would like to reject ${invitation?.companyName} Admin Access?`
          : `Are you sure you would like to reject ${invitation?.companyName} invitation?`;
    }
    const choice = await this.dialogConfirmation.confirm(message, '', ConfirmDialogType.YesNo);
    if (choice === ConfirmDialogResult.Yes) {
      const id = type === InviteType.Admin_Invite ? invitation?.qpAdminInviteId : invitation?.qpInviteId;
      this.qpInvitationService.editQualifiedPersonInvite(new EditQualifiedPersonInviteCommand({ uniqueId: id, status }), () => {
        const query = new SearchQuery().setPageIndex(undefined).setPageSize(undefined);
        this.qpInvitationService.loadQPInvitations(query);
      });
    }
  }
}
